import React from 'react';
import styles from './styles.module.scss';

export const ProductName = ({ name }) => (
  <div className={styles.productName}>{name}</div>
);
